<template>
    <div class="notification">
        <div class="notification__icon" @click="togglePopup">
            <i class="material-icons">notification_important</i>
            <span v-if="notificationsCount < 100">{{notificationsCount}}</span>
            <span v-else>99+</span>
        </div>
        <transition name="notification__anim">
            <div class="notification__popup" v-if="showPopup">
                <h4>Notificaties</h4>
                <ul class="notification__popup__inner"  v-if="noItems === false">
                        <notification-item 
                      
                            v-for="(notification, idx) in notifications" 
                            :key="notification.id" 
                            :item="notification" 
                            :idx="idx"
                            @update="update"
                            @remove="remove"
                            />
                                       

                    <infinite-loading  @infinite="loadMore" ref="infiniteLoading"  spinner="spiral"></infinite-loading>
                    
                </ul>
                <div class="no-notifications" v-else>Geen notificaties gevonden.</div>
                <div class="notification-controls">
                    <div class="notification__popup__controls">
                        <i class="material-icons" @click="refresh">
                            cached
                        </i>
                    </div>
                    <div class="notification__popup__controls">
                        <i class="material-icons" @click="readAll">
                           delete sweep
                        </i>
                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
    import notificationItem from './notification-item.vue';
    import InfiniteLoading from 'vue-infinite-loading';
    export default {
        data(){
            return{
                showPopup: false,
                unread_notifications_count: null,
                notifications: [],
                currentPage: 0,
                maxPages: null,
                noItems: false
            }
        },
        mounted(){
            let self = this; 
            this.$root.$on('hide_notification', () => {
              self.showPopup = false;
            }) ;
        },
        computed: {
            notificationsCount(){
                let notifications = 0;

                if(this.unread_notifications_count === null){
                    if(this.$store.state.user.data && this.$store.state.user.data.unread_notifications_count){
                        notifications = this.$store.state.user.data.unread_notifications_count;
                    }
        
                }else{
                    notifications = this.unread_notifications_count;
                }

                return notifications;
            },
        },
        methods: {
            refresh(){
                this.notifications = [];
                this.currentPage = 0;
                this.maxPages = null;
                this.noItems = false;
                this.$nextTick(() => {
                    this.$refs.infiniteLoading.attemptLoad();
                });
            },
            async readAll(){
            
                 try {
                    let read = await this.$axios.put('/users/notifications/readAll');

                    this.notifications = [];
                    this.currentPage = 0;
                    this.maxPages = null;
                    this.noItems = false;
                    
                    this.$emit('update', {
                        item: read.data,
                        idx: this.idx
                    });
                    
                    this.$nextTick(() => {
                        this.$refs.infiniteLoading.attemptLoad();
                    });
                } catch (e) {
                    this.displayErrors(e.response.data.errors);
                }
               
            },
            async togglePopup(){
                if(this.showPopup) {
                    this.showPopup = false;
                }else{
                    this.$root.$emit('hide_shift_notification');
                    this.showPopup = true;
                }
                
            },
            update(payload, idx) {
                this.notifications[payload.idx].read_at = payload.item.read_at;
                if(payload.item.read_at !== null){
                    this.unread_notifications_count -= 1;
                }
                else{
                    this.unread_notifications_count += 1;
                }
            },
            remove(idx){
                this.notifications.splice(idx, 1);
                this.unread_notifications_count -= 1;
            },
            async loadMore($state){
                if(this.maxPages !== null && this.currentPage === this.maxPages) return false;
                this.currentPage +=1;
                try {
                    let {data} = await this.$axios.get(`users/notifications?page=${this.currentPage}`);
                    this.notifications =  this.notifications.concat(data.data);
                    this.unread_notifications_count = data.meta.unread_notifications_count;
                    this.maxPages = data.meta.last_page;
                    if(data.meta.total === 0){
                        this.noItems = true;
                    }
                    $state.loaded();
                } catch (error) {
                    console.error(error);
                }
            }
        },
        components: {
            notificationItem,
            InfiniteLoading
        }

        // EVERYBODY
        // `FreelancerInvoiceFailed` 
        // `FreelancerInvoiceGenerated` 

        // TEMP / FREELANCER
        // `ShiftInvitationNotification`

        // PLANNER
        // `InvitedUserIsInterested` 
        
        // ADMIN
        // `NewUserRegistered` 
        // `NewCompanyRegistered` 
        
    }
</script>

<style lang="scss" >
    @import '~styles/_vars.scss';

    .notification__anim{
            &-enter-active, &-leave-active {
                transition: all .2s;
                transform: translateY(0px);
            }
            &-enter, &-leave-to /* .fade-leave-active below version 2.1.8 */ {
                opacity: 0;
                transform: translateY(-20px);
            }
    }
    .notification{
        position: relative;
        display: inline-block;
        vertical-align: top;
        &__icon{
            padding: 20px;
            position: relative;
            user-select: none;
            cursor: pointer;
            span{
                font-size: 10px;
                background-color: $red;
                color: #FFF;
                border-radius: 50%;
                border: 2px solid #FFF;
                padding: 0px;
                text-align: center;
                position: absolute;
                top: 7px;
                right: 7px;
                height: 25px;
                width: 25px;
            }
        }
        &__popup{
            position: absolute;
            top: 70px;
            right: 0;
            background-color: #FFF;

            box-shadow: 0px 0px 20px #999;
            border-radius: 4px;
            
            h4{
                font-size: 18px;
                padding: 20px 20px 0px 20px;
            }
            &:after {
                bottom: 100%;
                right: 5%;
                border: solid transparent;
                content: " ";
                height: 0;
                width: 0;
                position: absolute;
                pointer-events: none;
                border-color: rgba(255, 255, 255, 0);
             
                border-bottom-color: #FFF;
                border-width: 10px;
                margin-left: -10px;
            }
            @media (max-width: 600px){
                position: fixed;
                right: 0;

                &:after{
                    display: none;
                }
            }
            .no-notifications{
                padding: 20px;
                min-width: 400px;
          
                font-size: 14px;

                @media (max-width: 600px){
                    min-width: 100vw;
                }
                    
              
            }
            &__inner{
                list-style: none;
                overflow-y:auto;
                min-height: 100px;
                max-height: 400px;
                width: 400px;
                // padding: 20px;


                li{
                    padding: 10px 20px;
                    border-bottom: 1px solid $grey;
                    display: flex;
                    justify-content: space-between;
                    &.read{
                        .notification__content{
                            opacity: 0.5;
                        }
                    }
                    .notification__content{
                        display: block;
                        max-width: 70%;
        
                        small{
                            display: block;
                            color: $dark-grey;
                        }

                        a{
                            color: #000;
                        }
                    }
                    .notification__actions{
                        margin-top: 10px;

                        i{
                            cursor: pointer;

                            &.markasread{

                                &.read{
                                    color: $secondary-color;
                                }
                            }
                            &.remove{
                                color: $red;
                            }
                        }
                    }
                }
            }
            &__controls{
                i{
                    padding: 10px;
                    cursor: pointer;
                    
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/notifications.vue